import React, { useState, useEffect } from 'react';
import { Box, Button, Card, CardContent, CardHeader, Icon, Typography } from '@mui/material';
import lineaNegocioApi from '../../../api/lineaNegocioApi';

const Dashboard = () => {
    const [dashboards, setDashboards] = useState([]);
    const [selectedDashboard, setSelectedDashboard] = useState(null);
    useEffect(() => {
        const fetchDashboards = async () => {
            try {
                const data = await lineaNegocioApi.getDashboardUser(); 
                setDashboards(data);
                if (data.length > 0) {
                    setSelectedDashboard(data[0]);
                }
            } catch (error) {
                console.error('Error al obtener los dashboards:', error);
            }
        };
        fetchDashboards();
    }, []);

    const handleDashboardSelection = (dashboard) => {
        setSelectedDashboard(dashboard);
    };

    return (
        <div>
            <Box mb={1}>
                <Box display="flex" flexWrap="wrap" gap={1}>
                    {dashboards.map((dashboard) => (
                        <Button
                            key={dashboard.id}
                            variant="outlined"
                            onClick={() => handleDashboardSelection(dashboard)}
                            sx={{
                                borderColor: selectedDashboard?.id === dashboard.id ? '#3f51b5' : '#e0e0e0', // Color del borde
                                color: selectedDashboard?.id === dashboard.id ? '#3f51b5' : '#616161', // Color del texto
                            }}
                        >   
                        {dashboard.name_linea_negocio}-{dashboard.name}
                        </Button>
                    ))}
                </Box>
            </Box>
                {selectedDashboard ? (
                    <Card>
                        <CardHeader title={selectedDashboard.name} />
                        <CardContent sx={{ height: '70vh' }}> 
                            <iframe src={selectedDashboard.url} style={{ width: '100%', height: '100%' }} />
                        </CardContent>
                    </Card>
                ) : (
                    <Typography variant="body1">No hay ningún dashboard seleccionado.</Typography>
                )}
        </div>
    );
};

export default Dashboard;
